import ApiService from "./api.service";

const AtendimentoService = {
  async getAtendimentos(params) {
    return await ApiService.get("/atendimentos", params);
  },

  async getAtendimento(id) {
    return await ApiService.get(`/atendimentos/${id}`);
  },

  async salvar(atendimento) {
    return await ApiService.post("/atendimentos/salvar", atendimento);
  },

  async excluir(id) {
    return await ApiService.get(`/atendimentos/excluir/${id}`);
  },

  async cancelar(id) {
    return await ApiService.get(`/atendimentos/cancelar/${id}`);
  },

  async ativar(id) {
    return await ApiService.get(`/atendimentos/ativar/${id}`);
  },

  async imprimir(id) {
    return await ApiService.getBlob(`/atendimentos/imprimir/${id}`);
  },

  async gerarRelatorioAtendimento(params) {
    return await ApiService.getBlob(
      "/atendimentos/relatorio-atendimento",
      params
    );
  },

  async obterStatus() {
    return await ApiService.get("/atendimentos/status");
  },

  async obterModelosRelatorio() {
    return await ApiService.get("/atendimentos/modelos-relatorio");
  },

  async obterFiltrosRelatorios() {
    return await ApiService.get("/atendimentos/filtros-relatorios");
  },

  async cancelarSelecionados(ids) {
    return await ApiService.post("/atendimentos/cancelar-selecionados", {
      ids,
    });
  },
};

export default AtendimentoService;
